import { graphql } from 'react-relay';

import { BrandMessageTemplateWindowPaginator_query$key } from '../../../relay/__generated__/BrandMessageTemplateWindowPaginator_query.graphql';
import FragmentWindowPaginator, { FragmentWindowPaginatorProps } from '../../core/FragmentWindowPaginator';
import Pagination from '../../page/Pagination';

const BrandMessageTemplateWindowPaginator_query = graphql`
  fragment BrandMessageTemplateWindowPaginator_query on Query
  @argumentDefinitions(
    filters: { type: BrandMessageTemplateFilter }
    order: { type: BrandMessageTemplateOrder }
    page: { type: Int, defaultValue: 1 }
    pageSize: { type: Int }
  )
  @refetchable(queryName: "BrandMessageTemplateWindowPaginatorRefreshQuery") {
    brandMessageTemplates(filters: $filters, order: $order, page: $page, pageSize: $pageSize) {
      totalCount
      pages {
        ...Pagination_pages
      }
      edges {
        node {
          id
        }
      }
      ...BrandMessageTemplateConnectionDataTable_brandMessageTemplateConnection
    }
  }
`;
type Props = {} & Omit<FragmentWindowPaginatorProps<BrandMessageTemplateWindowPaginator_query$key>, 'fragment'>;

const BrandMessageTemplateWindowPaginator = ({ ...props }: Props) => (
  <FragmentWindowPaginator fragment={BrandMessageTemplateWindowPaginator_query} {...props}>
    {(data, { loadPage }) =>
      props.children(data, {
        loadPage,
        renderPagination: (paginationProps) => (
          <Pagination {...paginationProps} pages={data.brandMessageTemplates.pages} loadPage={loadPage} />
        ),
      })
    }
  </FragmentWindowPaginator>
);

export default BrandMessageTemplateWindowPaginator;
